import visuals from './visuals.json';

export default {
  visuals,
};
